export default __webpack_public_path__ + "static/media/Naked-Addiction.458368f6.png";